module.exports = __webpack_public_path__ + "img/Vector.c8e49efa.svg";